import React from 'react';
import { ExportModal } from '@ecosystem/newron-client-lib';

const parseWithTags = (input: string) =>
  input.includes('<br') ? (
    <>
      {input.split(/<br\s*\/?>/i).map((part, i, arr) => (
        <React.Fragment key={i}>
          {part}
          {i < arr.length - 1 && <br />}
        </React.Fragment>
      ))}
    </>
  ) : (
    input
  );

export const WithExportModal = (props) => <ExportModal {...props} message={parseWithTags(props.message)} />;
